interface ISubscription {
  id: string;
}

export interface IMakeSubscriptionQueryResult {
  makeSubscriptionV3: ISubscription;
}

interface IAssignPrimaryPaymentMethod {
  success: boolean;
}

export interface IAssignPrimaryPaymentMethodResult {
  assignPrimaryPaymentMethod: IAssignPrimaryPaymentMethod;
}

export interface IPromotionCode {
  id: string;
  code: string;
  amountOff?: number | undefined;
  percentOff?: number | undefined;
}

export enum PaymentMethodType {
  IBAN = 'sepa',
  CB = 'credit_card',
  PAYPAL = 'paypal',
  APPLE_PAY = 'apple_pay',
}

export enum FreeTrialStartedFromOriginEnum {
  generic = 'generic',
  checkout = 'checkout',
}

export enum MembershipPlan {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum SubscriptionStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
  NOT_STARTED = 'not started',
}
